import { render, staticRenderFns } from "./RestockLists.vue?vue&type=template&id=52a0b03a&scoped=true"
import script from "./RestockLists.vue?vue&type=script&lang=js"
export * from "./RestockLists.vue?vue&type=script&lang=js"
import style0 from "./RestockLists.vue?vue&type=style&index=0&id=52a0b03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0b03a",
  null
  
)

export default component.exports